import { render, staticRenderFns } from "./ComponenteBusqueda.vue?vue&type=template&id=564fefb1&scoped=true&"
import script from "./ComponenteBusqueda.vue?vue&type=script&lang=js&"
export * from "./ComponenteBusqueda.vue?vue&type=script&lang=js&"
import style0 from "./ComponenteBusqueda.vue?vue&type=style&index=0&id=564fefb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564fefb1",
  null
  
)

export default component.exports